import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { ImInfo } from 'react-icons/im';
import { log } from 'utils';
import ChartFolioVolBuy from '../chart/chartFolioVolBuy';
import ChartKNMuaRong from '../chart/chartKNMuaRong';

import ChartMarketNNBuy from '../chart/chartMarketNNBuy';
import { connect } from 'react-redux';
import * as _ from 'lodash'
const appUrl = `${process.env.REACT_APP_ALGO_API_URL}`;

function usePrevious(value) {
  const ref = React.useRef();

  React.useEffect(() => {
    ref.current = value;
  }, [value]); // Only re-run if value changes

  return ref.current;
}

function TabToChuc(props) {
  const [topAnhHuong, setTopAnhHuong] = React.useState(null);
  const [thanhKhoan, setThanhKhoan] = React.useState(null);
  const [intervalId, setIntervalId] = React.useState(null);

  const { marketActive, typeOrder, t, theme, algoCache } = props;
  const preAlgoCache = usePrevious(algoCache)

  const abortController = new AbortController();

  React.useEffect(() => {
    return () => {
      abortController.abort();
      if (intervalId) clearInterval(intervalId);
    };
  }, []);
  
  React.useEffect(() => {
    if(algoCache && !_.isEqual(algoCache, preAlgoCache)){
      if(algoCache?.ID?.toUpperCase() === marketActive && algoCache?.KEY.split(':')[2] === 'F_TRADING' ){
        setTopAnhHuong(algoCache?.DATA)
      }
      if(algoCache?.ID?.toUpperCase() === marketActive && algoCache?.KEY.split(':')[2] === 'PIvalue' ){
        setThanhKhoan(algoCache?.DATA)
      }
    }
  }, [algoCache])

  React.useEffect(() => {
    let _intervalId;
    if (marketActive) {
      if (intervalId) clearInterval(intervalId);
      loadKhoiNgoaiMuaRong();
      loadThanhKhoan();

      // _intervalId = setInterval(() => {
      //   loadKhoiNgoaiMuaRong();
      //   loadThanhKhoan();
      // }, 10 * 1000);

      // setIntervalId(_intervalId);
    }
    return () => {
      if (_intervalId) clearInterval(_intervalId);
    };
  }, [marketActive]);

  function loadKhoiNgoaiMuaRong() {
    fetch(appUrl + 'pbapi/api/Fvalue?id=' + marketActive, {
      signal: abortController.signal,
    })
      .then((response) => response.json())
      .then((res) => {
        // log(res);
        setTopAnhHuong(res);
      })
      .catch((error) => {
        log(error);
      });
  }

  function loadThanhKhoan() {
    fetch(appUrl + 'pbapi/api/PIvalue?id=' + marketActive, {
      signal: abortController.signal,
    })
      .then((response) => response.json())
      .then((res) => {
        // log(res);
        setThanhKhoan(res.data);
      })
      .catch((error) => {
        log(error);
      });
  }

  return (
    <div
      className="d-grid w-100 h-100"
      style={{ gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: '15px' }}
    >
      <div
        className="w-100"
        style={{ background: theme === 'dark' ? '#110E1E' : '#ffffff', borderRadius: '4px' }}
      >
        <p
          className=" d-flex align-items-center justify-content-center mb-0 text-white text-uppercase fz-14 fw-500"
          style={{ padding: '12px' }}
        >
          {t('algo.pttt.txt-Foreigner-trading-volume')} {' '}
          <OverlayTrigger
            // placement="right"
            overlay={
              <Tooltip id={`tooltip-right`}>
                {t('algo.chart.kl-kn-mua-rong')} {topAnhHuong?.dataDate}
              </Tooltip>
            }
          >
            <ImInfo className="ml-2 fz-12" />
          </OverlayTrigger>
        </p>
        <div className="w-100" style={{ height: 'calc(50vh - 140px)' }}>
          <ChartKNMuaRong tangGiam={topAnhHuong} typeOrder={typeOrder} afterFix={'CP'}/>
        </div>
      </div>
      <div
        className="w-100"
        style={{ background: theme === 'dark' ? '#110E1E' : '#ffffff', borderRadius: '4px' }}
      >
        <p
          className=" d-flex align-items-center justify-content-center mb-0 text-white text-uppercase fz-14 fw-500"
          style={{ padding: '12px' }}
        >
          {t('algo.pttt.txt-Foreigner-trading-value')} {' '}
          <OverlayTrigger
            // placement="right"
            overlay={
              <Tooltip id={`tooltip-right`}>
                {t('algo.chart.gt-kn-mua-rong')} {' '}
                {topAnhHuong?.dataDate}
              </Tooltip>
            }
          >
            <ImInfo className="ml-2 fz-12" />
          </OverlayTrigger>
        </p>
        <div className="w-100" style={{ height: 'calc(50vh - 140px)' }}>
          <ChartMarketNNBuy tangGiam={topAnhHuong} typeOrder={typeOrder} afterFix={'triệu'}/>
        </div>
      </div>
      <div
        className="w-100"
        style={{ background: theme === 'dark' ? '#110E1E' : '#ffffff', borderRadius: '4px' }}
      >
        <p
          className=" d-flex align-items-center justify-content-center mb-0 text-white text-uppercase fz-14 fw-500"
          style={{ padding: '12px' }}
        >
          {t('algo.pttt.txt-Proprietary-trading-volume')} {' '}
          <OverlayTrigger
            // placement="right"
            overlay={
              <Tooltip id={`tooltip-right`}>
                {t('algo.chart.kl-td-mua-rong')} {' '}
                {thanhKhoan?.dataDate}
              </Tooltip>
            }
          >
            <ImInfo className="ml-2 fz-12" />
          </OverlayTrigger>
        </p>
        <div className="w-100" style={{ height: 'calc(50vh - 140px)' }}>
          <ChartFolioVolBuy
            thanhKhoan={thanhKhoan}
            typeOrder={typeOrder}
            type={'Vol'}
            afterFix={'CP'}
          />
        </div>
      </div>
      <div
        className="w-100"
        style={{ background: theme === 'dark' ? '#110E1E' : '#ffffff', borderRadius: '4px' }}
      >
        <p
          className=" d-flex align-items-center justify-content-center mb-0 text-white text-uppercase fz-14 fw-500"
          style={{ padding: '12px' }}
        >
          {t('algo.pttt.txt-Proprietary-trading-value')} {' '}
          <OverlayTrigger
            // placement="right"
            overlay={
              <Tooltip id={`tooltip-right`}>
                {t('algo.chart.gt-td-mua-rong')} {thanhKhoan?.dataDate}
              </Tooltip>
            }
          >
            <ImInfo className="ml-2 fz-12" />
          </OverlayTrigger>
        </p>
        <div className="w-100" style={{ height: 'calc(50vh - 140px)' }}>
          <ChartFolioVolBuy
            thanhKhoan={thanhKhoan}
            typeOrder={typeOrder}
            type={'Value'}
            afterFix={'triệu'}
          />
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    algoCache: state.socket.algoCache,
  }
}

export default connect(mapStateToProps)(TabToChuc)
